import { call, put, select, takeLeading } from 'redux-saga/effects';

import { types as userTypes } from '@elab/core/store/user';
import { selectors as globalSelectors } from '@elab/core/store/global';
import authCookiesManager from '@elab/core/utils/authCookiesManager';

import wishlistActions from '../wishlist/actions';
import logger from '../../utils/logger';

import actions from './actions';
import api from './api';

import { selectors, types } from '.';

export function* loadAllWishlists({ payload }) {
    const anonymous = yield call(authCookiesManager.isAnonymous);
    const multipleWishlistsEnabled = yield select(globalSelectors.multipleWishlistsEnabled);

    try {
        if (!anonymous && multipleWishlistsEnabled) {
            yield put(actions.setLoading(true));
            const response = yield call(api.loadAllWishlists, payload && payload.name);
            yield put(actions.setWishlists(response));
        }
    } catch (e) {
        yield call(logger.error, e);
    } finally {
        yield put(actions.setLoading(false));
    }
}

export function* moveToWishlist({ payload }) {
    yield put(actions.setLoading(true));
    try {
        const { targetWishlistCode, activeWishlistCode, productCode } = payload;
        yield call(api.moveToWishlist, targetWishlistCode, activeWishlistCode, productCode);
        yield call(reloadWishlists, activeWishlistCode);
    } catch (e) {
        yield call(logger.error, e);
    } finally {
        yield put(actions.setLoading(false));
    }
}

export function* reloadWishlists(activeWishlistCode) {
    yield put(actions.loadAllWishlists());

    const wishlists = yield select(selectors.getWishlistEntries);
    const activeWishlist = wishlists.find(wishlist => wishlist.code === activeWishlistCode);

    yield put(wishlistActions.setWishlist(activeWishlist));
}

export default [
    takeLeading([types.LOAD_WISHLISTS, userTypes.SET_PROFILE], loadAllWishlists),
    takeLeading(types.MOVE_TO_WISHLIST, moveToWishlist),
];
